import React from 'react';
import {Container, makeStyles} from '@material-ui/core';

const useStyle =  makeStyles(theme => ({
    curtain: props => ({
        backgroundColor: props.backgroundColor && eval(props.backgroundColor) || 'white',
        padding: props.padding || '0px',
        boxShadow: props.boxShadow || 'none',
        position: props.position || 'initial',
        width: props.width || 'auto',
        textAlign: props.textAlign || 'left',
        
        [theme.breakpoints.down("xs")]: {
            padding:  props.xsPadding ||'50px 25px 25px 25px',
            fontSize: '36px'
        }
    })

}));
export default (props) => {
    const classes = useStyle(props);
    const { maxWidth } = props;
    return (
        <div className={classes.curtain} style={{...props.curtain}}>
            <Container maxWidth={maxWidth||"xl"}>
                {props.children}
            </Container>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/client/components/Container.js